import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import { AiOutlineCloudUpload } from "react-icons/ai";
import { MdClear } from "react-icons/md";
import { useTranslation } from "react-i18next";
import AppButton from "../../shared/AppButton";

const DragNdrop = forwardRef(({ width, height, formik, onRemoveFile }, ref) => {
  const [files, setFiles] = useState("");
  const { t, i18n } = useTranslation();

  const handleRemoveFile = () => {
    setFiles("");
    formik.setFieldValue("file", null);
    if (onRemoveFile) onRemoveFile();
  };

  useImperativeHandle(ref, () => ({
    reset: () => setFiles(""),
  }));

  const handleFileChange = (event) => {
    const selectedFiles = event.target.files[0];
    if (selectedFiles) setFiles(selectedFiles);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    const droppedFiles = event.dataTransfer.files[0];
    if (droppedFiles) setFiles(droppedFiles);
  };

  useEffect(() => {
    formik.setFieldValue("file", files);
  }, [files]);

  return (
    <div style={{ width, height }}>
      <div
        onDrop={handleDrop}
        onDragOver={(e) => e.preventDefault()}
        className={`border-2 border-dashed rounded-lg px-3 py-3 flex flex-col items-center justify-center text-center transition-colors cursor-pointer ${
          files
            ? "border-[#0070C2] bg-blue-50"
            : "border-gray-300 bg-slate-50 hover:border-[#0070C2] hover:bg-blue-50/40"
        }`}
      >
        {/* Icon */}
        <AiOutlineCloudUpload
          className={`text-3xl mb-2 ${files ? "text-[#0070C2]" : "text-gray-400"}`}
        />

        {/* Text */}
        <p className="text-xs font-semibold text-gray-600">
          {t("Drag and drop your files here")}
        </p>
        <p className="text-[10px] text-gray-400 mt-0.5">
          {t("Limit 16MB per file. Supported file: .XLSX")}
        </p>

        {/* Browse Button */}
        <input
          type="file"
          hidden
          id="browse"
          onChange={handleFileChange}
          accept=".xlsx"
        />
        <label htmlFor="browse" className="mt-2">
          <AppButton
            label={t("Browse files")}
            onClick={() => document.getElementById("browse").click()}
            className="!py-0.5 !px-3 !text-[11px]"
          />
        </label>
      </div>

      {/* Selected File */}
      {files && (
        <div className="mt-2 flex items-center justify-between bg-blue-50 border border-blue-200 rounded-lg px-3 py-1.5">
          <span className="text-xs text-[#0070C2] font-medium truncate max-w-[80%]">
            📄 {files.name}
          </span>
          <MdClear
            className="text-gray-400 hover:text-red-500 cursor-pointer flex-shrink-0 transition-colors"
            onClick={handleRemoveFile}
          />
        </div>
      )}
    </div>
  );
});

export default DragNdrop;
